import { commonFilter } from './filter';

export default {
  pageName: 'Steam Insights',
  pageId: '20118',
  pagePath: '/opinion/SteamPerformance/Insights',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
